"use client";
import {
  useToolbarStore
} from "../__chunks/7M5THDKH.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import {
  ToolbarContextProvider
} from "../__chunks/A3WPL2ZJ.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-provider.tsx
import { jsx } from "react/jsx-runtime";
function ToolbarProvider(props = {}) {
  const store = useToolbarStore(props);
  return /* @__PURE__ */ jsx(ToolbarContextProvider, { value: store, children: props.children });
}
export {
  ToolbarProvider
};
